import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


// const endpoint = environment.apiProcessorUrl;
const endpoint = environment.apiBaseUrl + '/asistente';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ConciergeService {
  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  askForHandler(ctx): Observable<any> {
    //console.log("askForHandler():: Request context: %s", JSON.stringify(ctx));
    return this.http.post<any>(endpoint + '/askForHandler', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  horarioAtencionServicio(req): Observable<any> {
    return this.http.post<any>(endpoint + '/horarioAtencionServicio', JSON.stringify(req),
      httpOptions).pipe(map(this.extractData)
      );
  }

  getCodigoEncuesta(codigoAsistente: string,idNodo: string): Observable<any> {
    const req = {
      codAsistente:codigoAsistente,
      idNodo:idNodo
    };
    return this.http.post<any>(endpoint + '/puf/getcodigo', JSON.stringify(req),
      httpOptions).pipe(map(this.extractData)
    );
  }

}
